<template>
  <component :is="layout">
    <router-view @update:layout="updateLayout"></router-view>
  </component>
</template>

<script lang="ts" setup>
import { shallowRef } from "vue";
import { ZccLayout } from "@planbord/ui/layouts";

const layout = shallowRef(ZccLayout);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function updateLayout(newLayout: any) {
  if (!newLayout) {
    return;
  }

  layout.value = newLayout;
}
</script>

<style lang="scss">
body {
  //remove default body margins
  margin: 0;
}

#app {
  /**
 * Remove focus styles for non-keyboard focus.
 */
  :focus:not(:focus-visible) {
    outline: 0;
    box-shadow: none;
  }

  /**
 * Cross-browser styles for explicit focus via
 * keyboard-based (eg Tab) navigation or the
 * .focus-visible utility class.
 */
  :focus,
  .focus-visible:focus:not(:focus-visible) {
    outline: 0;
    box-shadow: none;
  }
}
</style>
